import { render, staticRenderFns } from "./DashboardSummaryBox.vue?vue&type=template&id=1f9a7fcd&scoped=true&"
import script from "./DashboardSummaryBox.vue?vue&type=script&lang=ts&"
export * from "./DashboardSummaryBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9a7fcd",
  null
  
)

export default component.exports